import { useEffect, useRef } from 'react';

// Tipagem do beforeinstallprompt (não existe nativa no TS)
interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}
declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
  interface Window {
    __acorPWA?: {
      deferred: BeforeInstallPromptEvent | null;
      triggerInstall: () => Promise<'accepted' | 'dismissed' | 'unsupported'>;
      canPrompt: () => boolean;
    }
  }
}

function ensureGlobal() {
  if (!window.__acorPWA) {
    window.__acorPWA = {
      deferred: null,
      triggerInstall: async () => 'unsupported' as const,
      canPrompt: () => false
    };
  }
}

export default function InstallPWA() {
  const deferredRef = useRef<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    ensureGlobal();

    const onBIP = (e: BeforeInstallPromptEvent) => {
      e.preventDefault();
      deferredRef.current = e;
      ensureGlobal();
      window.__acorPWA!.deferred = e;
      window.dispatchEvent(new CustomEvent('acor:pwa:canprompt', { detail: true }));
    };
    const onInstalled = () => {
      ensureGlobal();
      window.__acorPWA!.deferred = null;
      window.dispatchEvent(new Event('acor:pwa:installed'));
      localStorage.setItem('acor-pwa-installed', String(Date.now()));
    };

    window.addEventListener('beforeinstallprompt', onBIP);
    window.addEventListener('appinstalled', onInstalled);

    // API pública para o botão já existente
    window.__acorPWA!.triggerInstall = async () => {
      const ev = deferredRef.current;
      if (!ev) return 'unsupported';
      await ev.prompt();
      const choice = await ev.userChoice;
      return choice?.outcome ?? 'dismissed';
    };
    window.__acorPWA!.canPrompt = () => !!deferredRef.current;

    return () => {
      window.removeEventListener('beforeinstallprompt', onBIP);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  // Headless: sem UI
  return null;
}